import { combineReducers } from 'redux';
import { uniq } from 'lodash';
import * as types from '../constants';

const ids = (state = [], action) => {
  switch (action.type) {
    case types.FETCH_BRANDS_SUCCESS:
      return action.response.result;
    case types.SAVE_BRAND_SUCCESS:
      return uniq([...state, action.response.result]);
    case types.DELETE_BRAND_SUCCESS:
      return state.filter(id => id !== action.brandId);
    default:
      return state;
  }
};

const isFetched = (state = false, action) => {
  switch (action.type) {
    case types.FETCH_BRANDS_SUCCESS:
      return true;
    case types.SAVE_BRAND_SUCCESS:
    case types.DELETE_BRAND_SUCCESS:
      return false;
    default:
      return state;
  }
};

export default combineReducers({
  ids,
  isFetched,
});

export const getIds = state => state.ids;
